<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
html {
  font-size: 1rem;
  height: 100%;
}
body {
  height: 100%;
  margin: 0;
}
* {
  box-sizing: border-box;
}
#app {
  font-family: Lato, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  min-height: 100%;
  display: flex;
  align-items: stretch;
}
.flex-grow {
  flex-grow: 1;
}
.flex-grow-99999 {
  flex-grow: 99999;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
$flex-positions: (start: flex-start, end: flex-end, center: center);
@each $position, $css-position in $flex-positions {
  .justify-items-#{$position} {
    justify-items: $css-position;
  }
  .align-items-#{$position} {
    align-items: $css-position;
  }
}
.justify-content-between {
  justify-content: space-between;
}
</style>
